import React from 'react';
import * as d3 from 'd3';
// import { rgb } from 'd3-color';
import { scaleLinear } from 'd3-scale';
// import {Typography} from '@material-ui/core';
// import { BorderColor } from '@material-ui/icons';

export default (props) => {
  const { markers, size, color } = props;
  const leftTextWidth = 10;
  const rightTextWidth = 10;
  const adjustedWidth = size.width - (leftTextWidth + rightTextWidth);
  const lineHeight = 50;
  const lineThickness = 14;
  const circleMarkerRadius = 3;

  const markerValues = markers.map((m) => +m.value);
  const total = d3.sum(markerValues);

  for (let i = 0; i < markers.length; i++) {
    markers[i].cumSum =
      i === 0 ? 0 : markers[i - 1].cumSum + markers[i - 1].value;
  }

  const scale = scaleLinear().domain([0, total]).range([0, adjustedWidth]);

  const pathStartEnd = (marker) => {
    var { value, cumSum, pointerPos } = marker;
    value = +value;
    cumSum = +cumSum;
    let start = { x: 0, y: 0 };
    let end = { x: 0, y: 0 };

    if (pointerPos.split('-')[0] === 'top') {
      start.y = lineHeight / 4 - lineThickness / 2;
      end.y = circleMarkerRadius;
    }
    if (pointerPos.split('-')[0] === 'bottom') {
      start.y = lineHeight / 4 - lineThickness / 2 + lineThickness;
      end.y = lineHeight - circleMarkerRadius;
    }
    if (pointerPos.split('-')[1] === 'left')
      end.x = size.width * 0.25 - leftTextWidth;
    if (pointerPos.split('-')[1] === 'right')
      end.x = size.width * 0.75 - leftTextWidth;

    start.x = scale(value / 2 + cumSum);
    return { start: start, end: end };
  };

  const drawPath = (start, end) => {
    // console.log(start,end);
    return (
      'M' +
      start.x +
      ' ' +
      start.y +
      'C' +
      start.x +
      ' ' +
      (start.y + (end.y - start.y > 0 ? 1 : -1) * Math.abs(start.y - end.y)) +
      ',' +
      end.x +
      ' ' +
      (end.y - (end.y - start.y > 0 ? 1 : -1) * Math.abs(start.y - end.y)) +
      ',' +
      end.x +
      ' ' +
      end.y
    );
  };

  return (
    <div style={{ display: 'flex' }}>
      {/* <Typography variant="h6" color="primary" style={{paddingTop:(lineHeight/2-lineThickness)}}> </Typography> */}
      <div
        style={{
          paddingLeft: leftTextWidth + 'px',
          paddingRight: rightTextWidth + 'px',
        }}
      >
        <svg className="lineMarker" width={adjustedWidth} height={lineHeight}>
          <g className="lineMarkerG" height={lineHeight}>
            {/* <rect 
              height={lineThickness} 
              width={adjustedWidth} 
              x={0} 
              y={lineHeight/2}
              fill={color.primary}/> */}
            {markers.map((m, i) => {
              if (+m.value === 0) return null;
              else
                return (
                  <rect
                    height={lineThickness}
                    width={scale(+m.value)}
                    x={scale(+m.cumSum)}
                    y={lineHeight / 4 - lineThickness / 2}
                    fill={color.secondary}
                    style={{ strokeWidth: 2, stroke: color.border }}
                  />
                );
            })}
            {markers.map((m) => {
              const { start, end } = pathStartEnd(m);
              if (+m.value === 0) return null;
              else
                return (
                  <g>
                    <path
                      d={drawPath(start, end)}
                      stroke={color.secondary}
                      fill="none"
                      strokeWidth={1}
                      key={'label' + m.markerPos}
                    ></path>
                    <circle
                      r={circleMarkerRadius}
                      cx={end.x}
                      cy={end.y}
                      fill={color.secondary}
                    />
                  </g>
                );
            })}
          </g>
        </svg>
      </div>
      {/* <Typography variant="h6" color="primary" style={{paddingTop:(lineHeight/2-lineThickness)}}> </Typography> */}
    </div>
  );
};
